import { notifyDesktopLogout } from './desktopBridge';
import { isPortalBuild } from './appTarget';
import { authSessionStorageKey, clearClientSessionData } from './authSession';
import { readStoredValue } from './storage';

/**
 * 명시적 로그아웃. 저장된 세션의 토큰으로만 폐기 API를 호출하고 클라이언트 저장소를 비운다.
 *
 * Portal 빌드에서는 Portal 세션만 끊는다 — web 세션은 별도 origin의 저장소에 있어
 * 애초에 이 경로가 건드리지 않는다. 이동 목적지도 다르다: web은 로그인 화면으로,
 * Portal은 자동 재로그인 루프를 피하려고 "로그아웃됨" 화면에 머문다.
 */
export const performLogout = async () => {
  try {
    const stored = readStoredValue(authSessionStorageKey);
    if (stored) {
      const parsed = JSON.parse(stored) as { token?: string; refreshToken?: string };
      if (parsed.token) {
        const { logoutApi } = await import('./api/auth');
        await logoutApi(parsed.token, parsed.refreshToken);
      }
    }
  } catch {
    // ignore — logout proceeds client-side
  }

  // callerHandlesRedirect: AuthGuard가 ?redirect=<현재경로>로 선점하지 않게 하고, 아래 이동만 남긴다.
  await clearClientSessionData({ callerHandlesRedirect: true });
  if (!notifyDesktopLogout()) {
    window.location.href = isPortalBuild ? '/auth/logged-out' : '/auth/login';
  }
};
